<template>
  <div class="home">
    <!-- vip页头 -->
    <vip-banner />

    <!-- 会员专享权益 -->
    <vip-production ref="production" />

    <!-- 尊享功能 -->
    <vip-service />

    <!-- 标讯订阅列表 -->
    <vip-subscription ref="subscription" />

    <!-- 我的关注 -->
    <div class="follow-block">
      <!-- 项目关注 -->
      <vip-follow-project ref="followProject" />
      <!-- 企业关注 -->
      <vip-follow-company ref="followCompany" />
    </div>
  </div>
</template>

<script>
// 组件
import VipBanner from '@/components/ValueAddedService/VipHome/VipBanner'
import VipProduction from '@/components/ValueAddedService/VipHome/VipProduction'
import VipService from '@/components/ValueAddedService/VipHome/VipService'
import VipSubscription from '@/components/ValueAddedService/VipHome/VipSubscription'
import VipFollowProject from '@/components/ValueAddedService/VipHome/VipFollowProject'
import VipFollowCompany from '@/components/ValueAddedService/VipHome/VipFollowCompany'
import { mapGetters, mapState } from 'vuex'
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'

export default {
  name: 'VipHome',

  components: {
    VipBanner,
    VipProduction,
    VipService,
    VipSubscription,
    VipFollowProject,
    VipFollowCompany
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('user', ['vipInfo', 'vipBalance']),
    ...mapState('company', ['companyName']),
    ...mapGetters('user', ['inVip'])
  },

  created() {
    this.$store.dispatch('user/getVipInfo').then(() => {
      this.$refs.production.getVipPackage()
      if (this.vipInfo?.productInfo?.productCode !== valueAddedProductCodeDict.REGULAR_VIP.value) {
        this.$refs.followProject.getFollowedProjectPage()
        this.$refs.followCompany.getFollowedCompanyPage()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: calc(1200px - 150px - 20px);
}

.follow-block {
  width: calc(1200px - 150px - 20px);
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  .detail-card {
    overflow: hidden;
    flex: 1;
  }
}
</style>
